import { Avatar } from '@/components/ui';
import { getNestedValue } from '@/lib/screen-utils';
import type { CellRendererProps } from './index';

export function AvatarCell({ value, row, config }: CellRendererProps) {
  const nameField = config?.nameField as string | undefined;
  const avatarField = config?.avatarField as string | undefined;
  const subtitleField = config?.subtitleField as string | undefined;
  const fallback = config?.fallback as string | undefined;

  // Resolve name: either from nameField (dot notation) or the direct value
  const name = nameField
    ? getNestedValue(row, nameField)
    : value;

  const avatarUrl = avatarField
    ? getNestedValue(row, avatarField)
    : null;

  const subtitleRaw = subtitleField
    ? getNestedValue(row, subtitleField)
    : null;
  const subtitle = subtitleRaw ? String(subtitleRaw) : null;

  // Guard: if name resolved to an object, config is likely misconfigured
  if (name && typeof name === 'object') {
    if (fallback) {
      return <span className="text-sm text-muted-foreground">{fallback}</span>;
    }
    return null;
  }

  // If no name and we have a fallback, show the fallback
  if (!name && fallback) {
    return <span className="text-sm text-muted-foreground">{fallback}</span>;
  }

  if (!name) return null;

  return (
    <div className="flex items-center gap-2">
      <Avatar
        fallback={String(name)}
        src={avatarUrl ? String(avatarUrl) : undefined}
        size="sm"
      />
      <div className="min-w-0">
        <span className="text-sm">{String(name)}</span>
        {subtitle && (
          <div className="text-xs text-muted-foreground">{subtitle}</div>
        )}
      </div>
    </div>
  );
}
